import Divider from '@portalterreno/react-ui-core/Divider';
import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import StyledWrapper from '../SubContent/StyledWrapper';
import Paginator from './Paginator';
import TitlePaginatorContainer from './TitlePaginatorContainer';

export type RelatedPropertiesHeaderProps = {
  title: string;
  currentPage: number;
  limitPages: number;
  handleNextPage: () => void;
  handlePrevPage: () => void;
};

const RelatedPropertiesHeader: React.FC<RelatedPropertiesHeaderProps> = ({
  handleNextPage,
  handlePrevPage,
  currentPage,
  limitPages,
  title
}) => {
  return (
    <React.Fragment>
      <Divider />
      <StyledWrapper>
        <TitlePaginatorContainer>
          <Typography
            variant='title'
            as='h2'
          >
            {title}
          </Typography>
          <Paginator
            currentPage={currentPage}
            limitPages={limitPages}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
          />
        </TitlePaginatorContainer>
      </StyledWrapper>
    </React.Fragment>
  );
};

export default RelatedPropertiesHeader;
